module.exports = __webpack_public_path__ + "a70f5e44d43827789e4a3f9985562425.fbx";